import { ContactSuggestionsResponse, ContactSummarySchema, ConversationDetailResponse, MatchContactRequest, } from '@aeris/contracts';
import { request } from "./client.js";
/** A conversa COM o painel do cliente — `party` é nulo enquanto o contato não estiver vinculado. */
export const fetchConversationDetail = async (conversationId, signal) => ConversationDetailResponse.parse(await request(`/api/v1/communication/conversations/${conversationId}`, {
    signal,
}));
/** As pessoas candidatas ao vínculo, pelo telefone. Não grava nada. */
export const fetchContactSuggestions = async (contactId, signal) => ContactSuggestionsResponse.parse(await request(`/api/v1/communication/contacts/${contactId}/suggestions`, {
    signal,
}));
/** Vincula o contato a uma pessoa já cadastrada. */
export const matchContact = async (contactId, input) => ContactSummarySchema.parse(await request(`/api/v1/communication/contacts/${contactId}/match`, {
    method: 'POST',
    body: MatchContactRequest.parse(input),
}));
/** "Não é nenhum destes" — o contato para de aparecer como pendente. */
export const ignoreContact = async (contactId) => ContactSummarySchema.parse(await request(`/api/v1/communication/contacts/${contactId}/ignore`, {
    method: 'POST',
}));
/**
 * Desfaz o vínculo (F084) — o número volta a esperar uma decisão.
 *
 * Não é o mesmo que `ignoreContact`: ignorar afirma que o número não é de
 * cliente; desvincular diz que a PESSOA escolhida está errada, e a tela volta a
 * oferecer os candidatos.
 */
export const unlinkContact = async (contactId) => ContactSummarySchema.parse(await request(`/api/v1/communication/contacts/${contactId}/unlink`, {
    method: 'POST',
}));
/** Cadastra uma pessoa nova a partir do contato, e já a vincula. */
export const createPartyForContact = async (contactId) => ContactSummarySchema.parse(await request(`/api/v1/communication/contacts/${contactId}/create-party`, {
    method: 'POST',
}));
//# sourceMappingURL=communication-contacts.js.map